var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{attrs:{"type":"border","icon-pack":"feather","size":"small","icon":"icon-plus"},on:{"click":function($event){return _vm.$emit('addGoal')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }